import { Controller } from "@hotwired/stimulus"

// Controller for quick-schedule dropdown on backlog/project task items
export default class extends Controller {
  static targets = ["trigger", "dropdown", "dateInput"]
  static values = {
    taskId: Number,
    rescheduleUrl: String
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropdownTarget.classList.toggle("hidden")

    if (!this.dropdownTarget.classList.contains("hidden")) {
      // Set up click-outside listener
      this.boundClickOutside = this.clickOutside.bind(this)
      document.addEventListener("click", this.boundClickOutside)
    } else {
      this.removeClickOutside()
    }
  }

  hide() {
    this.dropdownTarget.classList.add("hidden")
    this.removeClickOutside()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  removeClickOutside() {
    if (this.boundClickOutside) {
      document.removeEventListener("click", this.boundClickOutside)
      this.boundClickOutside = null
    }
  }

  disconnect() {
    this.removeClickOutside()
  }

  // Quick schedule options
  today(event) {
    event.preventDefault()
    const today = new Date().toISOString().split('T')[0]
    this.reschedule(today)
  }

  tomorrow(event) {
    event.preventDefault()
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.reschedule(tomorrow.toISOString().split('T')[0])
  }

  nextWeek(event) {
    event.preventDefault()
    const nextWeek = new Date()
    // Move to next Monday
    const dayOfWeek = nextWeek.getDay()
    const daysUntilMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek
    nextWeek.setDate(nextWeek.getDate() + daysUntilMonday)
    this.reschedule(nextWeek.toISOString().split('T')[0])
  }

  selectDate(event) {
    event.preventDefault()
    const dateValue = this.dateInputTarget.value
    if (dateValue) {
      this.reschedule(dateValue)
    }
  }

  reschedule(targetDate) {
    this.hide()

    const formData = new FormData()
    formData.append("target_date", targetDate)

    fetch(this.rescheduleUrlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        console.error("Reschedule failed:", response.status)
        return
      }
      return response.text()
    })
    .then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    })
    .catch(error => {
      console.error("Reschedule error:", error)
    })
  }
}
